import React from "react";
import { BreadcrumbItem } from "reactstrap";
import { v4 as uuidv4 } from "uuid";
import { Link } from "react-router-dom";

const Breadcrumbs = (props) => {
  // eslint-disable-next-line no-unused-vars
  const renderBreadcrumbs = () => {
    let route = props.url
      .split("/")
      .slice(1)
      .map((slice) =>
        slice
          .split("-")
          .map((word) =>
            word.length < 3
              ? word.toUpperCase()
              : word[0].toLowerCase() + word.slice(1)
          )
          .join(" ")
      );

    return route.map((item, index) => {
      let middlewareUrl =
        "/" +
        props.url
          .split("/")
          .slice(1, index + 2)
          .join("/");

      return (
        <BreadcrumbItem key={uuidv4()}>
          {route.length === index + 1 ? (
            item
          ) : (
            <Link to={middlewareUrl}>{item}</Link>
          )}
        </BreadcrumbItem>
      );
    });
  };

  const getBreadcrumbsTitle = () => {
    const routeArray = props.url.split("/");
    const title = routeArray[routeArray.length - 1];
    const subpath = routeArray[routeArray.length - 2];
    switch (title) {
      case "mcr_reports":
        return "Market Clearing Reports";
      case "mcr_ahead_reports":
        return "Market Clearing Reports (Ahead Runs)";
      case "period_average":
        return "Period Average Graph";
      case "device_management":
        return "Device Management";
      case "add":
        if (subpath === "bids") return "Add Variation Bid";
        return "Add Variation Offer";
      case "cdg_load_requests":
        return "Load Requests (from TMH)";
      case "demo":
        return "Monitoring Dashboard";
      case "solar_facilities":
        return "Solar Facilities";
      case "ebt_drs_consumers":
        return "EBT DRS Consumers";
      case "ebt_drs_inbox":
        return "EBT DRS Inbox";
      case "ebt_retail_consumers":
        return "EBT Retail Consumers";
      case "ebt_retail_inbox":
        return "EBT Retail Inbox";
      default:
        return title[0].toUpperCase() + title.slice(1);
    }
  };

  // Only render the page title, not breadcrumbs
  return (
    // getBreadcrumbsTitle() !== "Demo" && (
      <div className="mb-4">
        <div className="headline-2">
          {getBreadcrumbsTitle()}
        </div>
      </div>
    // )
  );
};

export default Breadcrumbs;
